import '../styles/modal.scss';

declare const bootstrap: any;

class Modal {
  private modalElement: HTMLElement;
  private modalTitle: HTMLElement;
  private modalBody: HTMLElement;
  private modalHeader : HTMLElement;
  private modalFooter : HTMLElement;
  private actionButton: HTMLElement;
  private modalImage: HTMLImageElement;
  private buttonClose: HTMLElement;
  private iconClose: HTMLElement;
  private themeModal: string;
  private bootstrapModal: any;

  constructor() {
    this.modalElement = document.getElementById('app-modal')!;
    this.modalTitle = document.getElementById('modal-title')!;
    this.modalBody = document.getElementById('modal-body')!;
    this.modalHeader = document.getElementById('modal-header')!;
    this.modalFooter = document.getElementById('modal-footer')!;
    this.actionButton = document.getElementById('actionButton')!;
    this.modalImage = this.modalElement.querySelector('img')!;
    this.buttonClose = document.getElementById('buttonClose')!;
    this.iconClose = document.getElementById('iconClose')!;
    this.themeModal = document.querySelector('body')!.classList.contains('dark-mode') ? 'dark' : 'light';

    this.bootstrapModal = new bootstrap.Modal(this.modalElement, {
      backdrop: true,
      keyboard: true
    });

    this.initEventListeners();
  }

  private initEventListeners(): void {
    document.querySelector('[data-dismiss="modal"]')?.addEventListener('click', () => this.hide());
  }

  public show(modalParams: any): void {
    const { title, body, textActionButton = '', actionCallback = null, image = null, hideCloseButton = false,
      hideCloseIcon = false, hideActionButton = false, disableBackdrop = false, theme = this.themeModal } = modalParams;

    const urlParams = new URLSearchParams(window.location.search);
    const isEmbed = urlParams.has('embed');

    this.modalTitle.innerHTML = title;
    this.modalBody.innerHTML = body;
    this.actionButton.innerHTML = textActionButton;
    this.modalElement.classList.remove('light-theme', 'dark-theme');
    this.modalElement.classList.add(theme === 'dark' ? 'dark-theme' : 'light-theme');

    this.modalImage.style.display = (image && !isEmbed) ? 'block' : 'none';
    if (image && !isEmbed) this.modalImage.src = image;

    this.buttonClose.style.display = hideCloseButton ? 'none' : 'block';
    this.iconClose.style.display =  hideCloseIcon ? 'none' : 'block';
    this.actionButton.style.display = hideActionButton ? 'none' : 'block';

    if (isEmbed) {
      this.iconClose.style.display = isEmbed ? 'none' :
      this.modalFooter.style.backgroundColor = 'none';
      this.modalElement.style.fontSize = '14px';
      this.modalElement.style.overflowY = 'hidden';
      this.modalBody.style.padding = '9px';
      this.modalHeader.style.padding = '9px';
      this.modalFooter.style.padding = '9px';
    }

    this.bootstrapModal._config.backdrop = disableBackdrop ? 'static' : true;
    this.bootstrapModal._config.keyboard = !disableBackdrop;

    this.actionButton.onclick = null;
    if (actionCallback) this.actionButton.onclick = actionCallback;

    this.bootstrapModal.show();
  }

  public hide(): void {
    this.bootstrapModal.hide();
  }
}

window['Modal'] = Modal;

export { Modal }
